import { Hero } from "../sections/Hero";
import { Marquee } from "../components/site/Marquee";
import { ValueProp } from "../sections/ValueProp";
import { Services } from "../sections/Services";
import { AppsConsulting, Modernization } from "../sections/AppsConsulting";
import { Automation } from "../sections/Automation";
import { AISection } from "../sections/AISection";
import { Process } from "../sections/Process";
import { Manifesto } from "../sections/Manifesto";
import { Cases, TechCapabilities } from "../sections/Cases";
import { FinalCTA } from "../sections/FinalCTA";

export default function HomePage() {
  return (
    <>
      <Hero />
      <Marquee />
      <ValueProp />
      <Services />
      <AppsConsulting />
      <Modernization />
      <Automation />
      <AISection />
      <Process />
      <Manifesto />
      <Cases />
      <TechCapabilities />
      <FinalCTA />
    </>
  );
}
